module.exports = __webpack_public_path__ + "static/media/report-background2.53521eae.png";